module.exports = __webpack_public_path__ + "img/appAsset-brand--axteroid-icon.72ef92e6.svg";